import { useMemo } from 'react';

import type { CoachChatConfig } from 'bundles/unified-common/providers/CoachStateProvider';
import { useCoursePageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffCourseContext';

type UseCourseContextConfigProps = {
  coachModeId: string;
  coachActionId: string;
};

const useCourseContextConfig = ({
  coachModeId,
  coachActionId,
}: UseCourseContextConfigProps): CoachChatConfig | undefined => {
  const coursePageData = useCoursePageData();
  const courseId = coursePageData?.id;

  return useMemo(() => {
    if (!courseId) {
      return undefined;
    }

    return {
      courseraContext: {
        courseId,
      },
      config: {
        coachModeId,
        coachActionId,
      },
    };
  }, [courseId, coachModeId, coachActionId]);
};

export default useCourseContextConfig;
